import { useEffect, useState, useCallback } from "react";
import { getComparisonRerunResultByRuleId } from "../services/rulesService";
import { comparisonRerunResultMockData } from "../services/constants/Rules";

interface FetchComparisonRerunResultProps {
  executionId: number | null;
  setIsLoading: (loading: boolean) => void
}

const useFetchComparisonRerunResultByRuleId = ({
  executionId,
  setIsLoading
}: FetchComparisonRerunResultProps) => {
  const [comparisonRerunResultData, setComparisonRerunResultData] =
    useState<any>(null);

  const fetchRerunResult = useCallback(async () => {
    if (executionId) {
      setIsLoading(true);
      try {
        //on temp bases mock data is set
        // setComparisonRerunResultData(comparisonRerunResultMockData);

        const result = await getComparisonRerunResultByRuleId(
          executionId
        );
        setComparisonRerunResultData(result);
      } catch (error) {
        setComparisonRerunResultData(null);
      } finally {
        setIsLoading(false);
      }
    }
  }, [executionId, setIsLoading]);

  useEffect(() => {
    fetchRerunResult();
  }, [fetchRerunResult]);

  return [comparisonRerunResultData];
};

export default useFetchComparisonRerunResultByRuleId;
